/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import {CommonModule} from '@angular/common';
// import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';

import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {NgModule, LOCALE_ID} from '@angular/core';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {CoreModule} from './@core/core.module';
import {ThemeModule} from './@theme/theme.module';
import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core'
import {TranslateHttpLoader} from '@ngx-translate/http-loader'

export function HttpLoaderFactory(http: HttpClient){
    //return new TranslateHttpLoader(http);
}


import {
    NbChatModule,
    NbProgressBarModule,
    NbDatepickerModule,
    NbDialogModule,
    NbMenuModule,
    NbSidebarModule,
    NbToastrModule,
    NbWindowModule,
    NbAlertModule,
    //    NbAlertModule,
    NbButtonModule,
    NbCheckboxModule,
    NbInputModule,
    NbIconModule
} from '@nebular/theme';

import {NbAuthModule} from '@nebular/auth';

// IMPORTACIONES PROPIAS-------------
// import { Globals } from 'globals.ts';
import {AngularFontAwesomeModule} from 'angular-font-awesome';

import {registerLocaleData} from '@angular/common';
import localeEn from '@angular/common/locales/en';
registerLocaleData(localeEn);

// SERVICIOS
import {SERVICES} from './services/';
import * as $ from 'jquery';
import { SharedModule } from './shared/shared.module';
//import { TranslationComponent } from './translation/translation.component';
//import { AuthComponent } from './auth/auth.component';
//import { LoginComponent } from './pages/login/login.component';


// modulo de login
// import {NgxAuthModule} from './auth/auth.module';

@NgModule({
    declarations: [AppComponent ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        TranslateModule.forRoot({
            loader:{
                provide: TranslateLoader,
                useFactory: (http: HttpClient) => {
                    return new TranslateHttpLoader (http, './assets/i18n/', '.json');
                },
                deps: [HttpClient]
            }
        }),
        //AppRoutingModule,
        ThemeModule.forRoot(),
        NbSidebarModule.forRoot(),
        NbMenuModule.forRoot(),
        NbDatepickerModule.forRoot(),
        NbDialogModule.forRoot(),
        NbWindowModule.forRoot(),
        NbToastrModule.forRoot(),
        NbChatModule.forRoot({
            messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
        }), 
        NbAlertModule,
        CoreModule.forRoot(),
        NbProgressBarModule,
        AngularFontAwesomeModule,
        AppRoutingModule,


        NbAlertModule,
        NbInputModule,
        NbButtonModule,
        NbCheckboxModule,
        NbIconModule,
        SharedModule.forRoot()
        //    NgxAuthRoutingModule,


    ],
    providers: [
        {provide: LOCALE_ID, useValue: 'en-*'},
        ...SERVICES,
    ],
    bootstrap: [AppComponent],
})
export class AppModule {
}
